import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { HeadingLevelProvider } from '@zapier/common-utils';

import AppList from 'app/zapbook/components/AppList';
import LoadingScreen from 'app/common/components/LoadingScreen';
import SearchBar from 'app/zapbook/components/SearchBar';

const Zapbook = createReactClass({
  displayName: 'Zapbook',
  mixins: [PureRenderMixin],

  propTypes: {
    servicesHaveLoaded: PropTypes.bool.isRequired,
    onChangeCategory: PropTypes.func.isRequired,
    onSearchServices: PropTypes.func.isRequired,
    onUpdateHash: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    filterBy: PropTypes.string.isRequired,
    services: PropTypes.array.isRequired,
    filteredServiceIds: PropTypes.arrayOf(PropTypes.number.isRequired),
    nonMatchingServiceIds: PropTypes.arrayOf(PropTypes.number.isRequired),
    sortCategories: PropTypes.array.isRequired,
    filterCategories: PropTypes.array.isRequired,
    isZapbookPage: PropTypes.bool.isRequired,
    isCategoryPage: PropTypes.bool.isRequired,
    isOneServicePage: PropTypes.bool.isRequired,
    isOnlyFirstHundred: PropTypes.bool,
    requestAddUpdates: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.object.isRequired,
        PropTypes.bool.isRequired,
      ]).isRequired
    ),
  },

  categoryTypes: {
    sort: 'SORT',
    filter: 'FILTER',
  },

  sortServices(key) {
    this.props.onUpdateHash(key, this.props.filterBy);
  },

  filterServices(key) {
    this.props.onChangeCategory(key, this.props.sortBy);
    // this.props.onUpdateHash(this.props.sortBy, key);
  },

  onSortOrFilter(categoryType, key) {
    return categoryType === this.categoryTypes.sort
      ? this.sortServices(key)
      : this.filterServices(key);
  },

  onSearchServices(e) {
    this.props.onSearchServices(e.target.value.toLowerCase());
  },

  render() {
    const { props } = this;
    //get the services that should be faded out, set them to isActive: false
    const nonMatchingServices = props.nonMatchingServiceIds.map(id => ({
      ...props.services[id],
      isActive: false,
    }));
    // add those to the end of the non-faded services,
    // and make sure all of those are isActive: true
    let services = _.get(props, 'filteredServiceIds', [])
      .map(id => ({ ..._.get(props, ['services', id]), isActive: true }))
      .concat(nonMatchingServices);

    if (props.isOnlyFirstHundred) {
      services = _.slice(services, 0, 100);
    }

    return (
      <HeadingLevelProvider level={1}>
        <div className="app zapbook">
          <div className="row" id="zapbook-picker">
            <div className="app-picker-container">
              <SearchBar onSearchServices={this.onSearchServices} />
              {!props.servicesHaveLoaded ? (
                <LoadingScreen showMessage={true} />
              ) : (
                <AppList
                  categoryTypes={this.categoryTypes}
                  filterBy={props.filterBy}
                  filterCategories={props.filterCategories}
                  isCategoryPage={props.isCategoryPage}
                  isOneServicePage={props.isOneServicePage}
                  isZapbookPage={props.isZapbookPage}
                  onSortOrFilter={this.onSortOrFilter}
                  requestAddUpdates={props.requestAddUpdates}
                  services={services}
                  sortBy={props.sortBy}
                  sortCategories={props.sortCategories}
                />
              )}
            </div>
          </div>
        </div>
      </HeadingLevelProvider>
    );
  },
});

export default Zapbook;
